export default {
  AJAX_UPDATED: 'AJAX_UPDATED',
  ADD_SCROLL_SUBSCRIPTION: 'ADD_SCROLL_SUBSCRIPTION',
  CART_EMPTY: 'CART_EMPTY',
  CART_UPDATED: 'CART_UPDATED',
  CLOSE_OVERLAY: 'CLOSE_OVERLAY',
  FILTER_CONTENT_UPDATED: 'FILTER_CONTENT_UPDATED',
  HEADER_OPEN: 'HEADER_OPEN',
  LOAD_IMAGES: 'LOAD_IMAGES',
  OPEN_OVERLAY: 'OPEN_OVERLAY',
  OPEN_ZOOM: 'OPEN_ZOOM',
  OVERLAY_OPENED: 'OVERLAY_OPENED',
  PARALLAX_ITEMS_ADDED: 'PARALLAX_ITEMS_ADDED',
  PRODUCT_DATA_LOADED: 'PRODUCT_DATA_LOADED',
  PRODUCT_IMAGES_UPDATED: 'PRODUCT_IMAGES_UPDATED',
  REVEAL_ITEMS_ADDED: 'REVEAL_ITEMS_ADDED',
  REMOVE_SCROLL_SUBSCRIPTION: 'REMOVE_SCROLL_SUBSCRIPTION',
  SCROLL_HANDLER_TRIGGERED: 'SCROLL_HANDLER_TRIGGERED',
  VARIANT_CHANGED: 'VARIANT_CHANGED',
  VERTICAL_SPACERS_UPDATED: 'VERTICAL_SPACERS_UPDATED',
  ZOOM_OPENED: 'ZOOM_OPENED',
  ITEM_ADDED_WIDGET: 'ITEM_ADDED_WIDGET',
  ITEM_ADDED_WIDGET_OPENED: 'ITEM_ADDED_WIDGET_OPENED',
  LOCATION_SET: 'LOCATION_SET',
  OPEN_SEARCH: 'OPEN_SEARCH',
  CLOSE_SEARCH: 'CLOSE_SEARCH',
  UPDATE_SEARCH: 'UPDATE_SEARCH',
  SELECT_PREDICTION_SEARCH: 'SELECT_PREDICTION_SEARCH',
};
